import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, Link, useLocation } from "react-router-dom";

import "./styles/App.css";

import { LoginForm } from "./components/LoginForm";
import { VedomList } from "./components/VedomList";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuth, AuthProvider } from "./context/auth_context_provider";
import { AgentsPage } from "./pages/AgentsPage";
import logo from "./logo.png";

const AppContent: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && location.pathname === '/login') {
      navigate("/");
    }
  }, [isAuthenticated, navigate, location.pathname]);

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <div className="title-container" onClick={handleLogoClick}>
            <img src={logo} alt="Tetris Logo" className="header-logo" />
            <h1>Tetris</h1>
            <h4>1.0.1</h4>
          </div>
          {isAuthenticated && (
            <div className="header-info">
              <span className="user-info">{user?.login}</span>
              <Link to="/agents" className="settings-link">
                ⚙️ Налаштування
              </Link>
              <button onClick={logout} className="logout-button">
                Logout
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<VedomList />} />
            <Route path="/agents" element={<AgentsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;